
import { Crown, CreditCard, User } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { usePlanInfo } from "@/hooks/usePlanInfo";

interface PlanInfoCardProps {
  planType: string;
  isActive: boolean;
  userRole?: string;
}

export function PlanInfoCard({ planType, isActive, userRole }: PlanInfoCardProps) {
  const { getPlanInfo } = usePlanInfo();
  const planInfo = getPlanInfo(planType);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <CreditCard className="h-5 w-5" />
          Minha Assinatura
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <Badge className={planInfo.color}>
                {planInfo.icon}
                <span className="ml-1">{planInfo.name}</span>
              </Badge>
            </div>
            <p className="text-sm text-muted-foreground">
              {planInfo.description}
            </p>
          </div>
          <div className="text-right">
            <p className="text-2xl font-bold">{planInfo.price}</p>
            <p className="text-sm text-muted-foreground">{planInfo.period}</p>
          </div>
        </div>

        <Separator />

        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <span className="text-muted-foreground">Status</span>
            <Badge className={isActive ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"}>
              {isActive ? "Ativo" : "Inativo"}
            </Badge>
          </div>
          
          <div className="flex justify-between items-center">
            <span className="text-muted-foreground">Método de pagamento</span>
            <span className="text-sm">
              {planType === 'premium' ? 'Anual' : 'Por carta'}
            </span>
          </div>

          {userRole === 'admin' && (
            <div className="flex justify-between items-center">
              <span className="text-muted-foreground">Função</span>
              <Badge className="bg-purple-100 text-purple-800">
                <Crown className="h-3 w-3 mr-1" />
                {userRole}
              </Badge>
            </div>
          )}
        </div>

        <Separator />

        <div className="space-y-2">
          <h4 className="font-medium">Benefícios do seu plano</h4>
          <ul className="text-sm text-muted-foreground space-y-1">
            {planType === 'premium' ? (
              <>
                <li>• Cartas ilimitadas</li>
                <li>• Suporte prioritário</li>
                <li>• Recursos premium</li>
              </>
            ) : (
              <>
                <li>• Cartas individuais</li>
                <li>• Suporte básico</li>
                <li>• Recursos essenciais</li>
              </>
            )}
          </ul>
        </div>
      </CardContent>
    </Card>
  );
}
